<template>
  <div class="leave-kanban">
    <div class="kanban-view-list">
      <v-flex class="kanban-innerlist">
        <div class="list-title">
          <div class="d-flex">
            <div class="fw-600 title-text">Pending</div>
            <v-spacer></v-spacer>
            <v-checkbox hide-details class="ma-0 pa-0 size-16"> </v-checkbox>
          </div>
          <div class="mt-1">
            <v-chip
              class="mb-1 mr-1"
              label
              color="orange darken-4 white--text"
              x-small
            >
              1 leave
            </v-chip>
          </div>
        </div>
        <Container
          group-name="leadkanbanlist"
          @drop="onDrop('list1', $event)"
          :get-child-payload="getChildPayload1"
          :drop-placeholder="dropPlaceholderOptions"
          class="overflow-list-item"
          :id="!list1.length ? 'blank-list' : ''"
        >
          <Draggable v-for="(data, index) in list1" :key="index" class="">
            <div class="list-items">
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">Staff : </span>
                <span class="fw-500">{{ data.staff }}</span>
              </div>
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">Start Date : </span>
                <span class="fw-500">{{ data.start_date }}</span>
              </div>
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">End Date : </span>
                <span class="fw-500">{{ data.end_date }}</span>
              </div>
              <div class="pr-6">
                <span class="fw-700 pr-2">Reason : </span>
                <span class="fw-500">{{ data.reason }}</span>
              </div>
              <span class="fw-700 pr-2">Half Day : </span>
              <v-chip
                class="mb-1 mr-1"
                label
                color="orange white--text"
                x-small
              >
                {{ data.half_day }}
              </v-chip>
              <v-checkbox hide-details class="ma-0 pa-0 size-16"> </v-checkbox>
            </div>
          </Draggable>
        </Container>
      </v-flex>
      <v-flex class="kanban-innerlist">
        <div class="list-title">
          <div class="d-flex">
            <div class="mr-2 fw-700 title-text">Approved</div>
            <v-spacer></v-spacer>
            <v-checkbox hide-details class="ma-0 pa-0 size-16"> </v-checkbox>
          </div>
          <div class="mt-1">
            <v-chip class="mb-1 mr-1" label color="green white--text" x-small>
              3 leave
            </v-chip>
          </div>
        </div>
        <Container
          group-name="leadkanbanlist"
          @drop="onDrop('list2', $event)"
          :get-child-payload="getChildPayload2"
          :drop-placeholder="dropPlaceholderOptions"
          class="overflow-list-item"
          :id="!list2.length ? 'blank-list' : ''"
        >
          <Draggable v-for="(data, index) in list2" :key="index" class="">
            <div class="list-items">
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">Staff : </span>
                <span class="fw-500">{{ data.staff }}</span>
              </div>
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">Start Date : </span>
                <span class="fw-500">{{ data.start_date }}</span>
              </div>
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">End Date : </span>
                <span class="fw-500">{{ data.end_date }}</span>
              </div>
              <div class="pr-6">
                <span class="fw-700 pr-2">Reason : </span>
                <span class="fw-500">{{ data.reason }}</span>
              </div>
              <span class="fw-700 pr-2">Half Day : </span>
              <v-chip
                class="mb-1 mr-1"
                label
                color="orange white--text"
                x-small
              >
                {{ data.half_day }}
              </v-chip>
              <v-checkbox hide-details class="ma-0 pa-0 size-16"> </v-checkbox>
            </div>
          </Draggable>
        </Container>
      </v-flex>
      <v-flex class="kanban-innerlist">
        <div class="list-title">
          <div class="d-flex">
            <div class="mr-2 fw-700 title-text">Rejected</div>
            <v-spacer></v-spacer>
            <v-checkbox hide-details class="ma-0 pa-0 size-16"> </v-checkbox>
          </div>
          <div class="mt-1">
            <v-chip
              class="mb-1 mr-1"
              label
              color="red white--text darken-4"
              x-small
            >
              3 leave
            </v-chip>
          </div>
        </div>
        <Container
          group-name="leadkanbanlist"
          @drop="onDrop('list3', $event)"
          :get-child-payload="getChildPayload3"
          :drop-placeholder="dropPlaceholderOptions"
          class="overflow-list-item"
          :id="!list3.length ? 'blank-list' : ''"
        >
          <Draggable v-for="(data, index) in list3" :key="index" class="">
            <div class="list-items">
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">Staff : </span>
                <span class="fw-500">{{ data.staff }}</span>
              </div>
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">Start Date : </span>
                <span class="fw-500">{{ data.start_date }}</span>
              </div>
              <div class="ellipsis pr-6">
                <span class="fw-700 pr-2">End Date : </span>
                <span class="fw-500">{{ data.end_date }}</span>
              </div>
              <div class="pr-6">
                <span class="fw-700 pr-2">Reason : </span>
                <span class="fw-500">{{ data.reason }}</span>
              </div>
              <span class="fw-700 pr-2">Half Day : </span>
              <v-chip
                class="mb-1 mr-1"
                label
                color="orange white--text"
                x-small
              >
                {{ data.half_day }}
              </v-chip>
              <v-checkbox hide-details class="ma-0 pa-0 size-16"> </v-checkbox>
            </div>
          </Draggable>
        </Container>
      </v-flex>
    </div>
  </div>
</template>
<script>
import { Container, Draggable } from "vue-smooth-dnd";
export default {
  name: "LeaveKanban",
  data() {
    return {
      dropPlaceholderOptions: {
        className: "lead-drop-preview",
        animationDuration: "50",
        showOnTop: true,
      },
      list1: [
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "Second Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
      ],
      list2: [
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "Second Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
      ],
      list3: [
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "Second Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
        {
          staff: "Development",
          start_date: "22/04/2022",
          end_date: "22/04/2022",
          reason:
            "I'll not be able to come office today because I am suffering from a cold or high fever",
          half_day: "First Half",
        },
      ],
    };
  },
  methods: {
    onDrop(collection, dropResult) {
      this[collection] = this.applyDrag(this[collection], dropResult);
    },
    getChildPayload1(index) {
      return this.list1[index];
    },
    getChildPayload2(index) {
      return this.list2[index];
    },
    getChildPayload3(index) {
      return this.list3[index];
    },
    getChildPayload4(index) {
      return this.list4[index];
    },
    getChildPayload5(index) {
      return this.list5[index];
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;
      const result = [...arr];
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }
      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }
      return result;
    },
  },
  components: {
    Container,
    Draggable,
  },
};
</script>
